/**
 * Role helpers for composite users.
 *
 * A user has ONE primary `role` plus zero or more `additional_roles`.
 * UI guards should call `hasRole(user, "referent")` instead of
 * `user.role === "referent"` so they correctly handle a pre-recruiter who
 * is also a field referent (and vice-versa).
 */

export function effectiveRoles(user) {
    if (!user) return new Set();
    const all = new Set();
    if (user.role) all.add(user.role);
    for (const r of user.additional_roles || []) {
        if (r) all.add(r);
    }
    return all;
}

export function hasRole(user, role) {
    return effectiveRoles(user).has(role);
}

export function hasAnyRole(user, ...roles) {
    const eff = effectiveRoles(user);
    return roles.some((r) => eff.has(r));
}

/** Pretty label for a user's roles, e.g. "Pré-recruteur + Référent terrain". */
export function rolesLabel(user, roleMeta) {
    const eff = Array.from(effectiveRoles(user));
    if (eff.length === 0) return "—";
    return eff.map((r) => roleMeta?.[r]?.label || r).join(" + ");
}
